import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class AdminSequenceApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.MANAGEMENT_SEQUENCE);
  }

  updateSequence(data) {
    return this.httpClient.put(`${this.getResourceUrl()}update/`, data);
  }
}

export default new AdminSequenceApi();
